<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
        <h5>Upload Candidates</h5>
        <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="uploadCandidates()">

            <div class="mb-3 mr-0 col-md-10">
                <label class="form-label">Select Excel File (.xlsx)*</label>
                <input type="file" class="form-control file-select" accept=".xlsx" (change)="onFileChange($event)">
            </div>

            <button class="btn btn-primary btn-lg col-md-10" type="submit" [disabled]="!uploadCand.file"> Upload
            </button>

        </form>
        <div class="d-flex flex-column align-items-start">
            <a href="/assets/templates/CandidateUploadTemplate.xlsx" download class="mt-2">
                Download Template</a>
        </div>
    </div>
</div>